import { t } from 'i18next';
import * as Yup from 'yup';

export const addLocalizationStatus = Yup.object({
  name: Yup.string().required(t('required-field')),
});
